// SEO data for all pages
export const seoData = {
  home: {
    title: "Premium Aluminium Manufacturing & Trading",
    description: "BB Industry - Leading aluminium manufacturer in Balangir, Odisha. Specialized in aluminium sheets, blanks, utensils, and scrap trading with 15+ years of experience and ISO certified quality standards.",
    keywords: "aluminium manufacturing, aluminum sheets, aluminum blanks, aluminum utensils, metal trading, ISO certified, Balangir Odisha, aluminum scrap, rolling mills, BB Industry",
    canonical: "/",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  visionMission: {
    title: "Vision & Mission - Building Future of Aluminium Industry",
    description: "Discover BB Industry's vision to transform the aluminium supply chain through innovation, quality excellence, and sustainable practices. Our mission drives technological advancement in metal manufacturing.",
    keywords: "BB Industry vision, aluminium industry mission, metal supply chain innovation, sustainable manufacturing, quality excellence",
    canonical: "/about-us/vision-mission",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  manufacturing: {
    title: "Advanced Aluminium Manufacturing Facility - Balangir, Odisha",
    description: "State-of-the-art aluminium manufacturing facility with three 4-Hi Rolling Mills, producing 200+ tonnes monthly. Advanced equipment for aluminium sheets, blanks, and utensils manufacturing.",
    keywords: "aluminium manufacturing facility, 4-Hi rolling mills, aluminum sheets production, aluminum blanks manufacturing, Balangir manufacturing unit",
    canonical: "/about-us/manufacturing",
    ogImage: "/images/rolling-mill-1.jpg"
  },
  
  certifications: {
    title: "ISO & BIS Certified Aluminium Manufacturing - Quality Assured",
    description: "BB Industry holds BIS certification for aluminium blanks, utensils, and stainless steel products. Comprehensive quality assurance with laboratory testing and compliance standards.",
    keywords: "BIS certified aluminium, ISO certification, quality assurance, aluminum blanks certification, steel utensils BIS, laboratory testing",
    canonical: "/about-us/certifications",
    ogImage: "/images/quality-control.jpg"
  },
  
  businesses: {
    title: "Aluminium Business Divisions - Manufacturing & Trading",
    description: "Explore BB Industry's diverse aluminium business portfolio including sheets, blanks, circles, utensils manufacturing, and comprehensive aluminium scrap trading operations.",
    keywords: "aluminium business divisions, aluminum sheets business, aluminum blanks trading, metal manufacturing services, aluminum scrap trading",
    canonical: "/businesses",
    ogImage: "/images/finished-products.jpg"
  },
  
  circlesBlanks: {
    title: "Aluminium Circles & Blanks Manufacturing - Precision Products",
    description: "High-quality aluminium circles and blanks manufacturing with BIS certification. Precision rolling mill operations producing superior quality products for various industrial applications.",
    keywords: "aluminium circles manufacturing, aluminum blanks production, BIS certified circles, precision aluminum products, rolling mill circles",
    canonical: "/businesses/circles-blanks",
    ogImage: "/images/finished-products.jpg"
  },
  
  utensils: {
    title: "Premium Aluminium & Steel Utensils Manufacturing",
    description: "BIS certified aluminium and stainless steel utensils manufacturing. Premium quality cookware and kitchen products with advanced spinning and pressing capabilities.",
    keywords: "aluminium utensils manufacturing, steel utensils BIS certified, cookware manufacturing, kitchen products aluminum, premium utensils",
    canonical: "/businesses/utensils-cookwares",
    ogImage: "/images/finished-products.jpg"
  },
  
  sheets: {
    title: "Aluminium Sheets Manufacturing - Industrial Grade Quality",
    description: "Industrial grade aluminium sheets manufacturing with 4-Hi rolling mills. Superior quality sheets for construction, automotive, and industrial applications with precise specifications.",
    keywords: "aluminium sheets manufacturing, industrial aluminum sheets, 4-Hi rolling mill, construction aluminum, automotive aluminum sheets",
    canonical: "/businesses/sheets",
    ogImage: "/images/rolling-mill-2.jpg"
  },
  
  scraps: {
    title: "Aluminium Scrap Trading & Import - Sustainable Metal Solutions",
    description: "Comprehensive aluminium scrap trading and import operations. Sustainable metal recycling solutions with expertise in all grades of aluminium scraps and materials.",
    keywords: "aluminium scrap trading, aluminum scrap import, metal recycling, sustainable aluminum, scrap metal trading, aluminum waste management",
    canonical: "/businesses/scraps",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  industries: {
    title: "Industries We Serve - Aluminium Solutions Across Sectors",
    description: "BB Industry serves diverse industries including automotive, construction, cookware, packaging, and electrical sectors with specialized aluminium products and solutions.",
    keywords: "aluminium industries served, automotive aluminum, construction metal solutions, cookware manufacturing, packaging aluminum, electrical aluminum",
    canonical: "/industries-we-serve",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  brands: {
    title: "Amogh Brand - Premium Aluminium Utensils & Cookware",
    description: "Amogh - Our premium brand of aluminium utensils and cookware. Trusted by households, restaurants, and hotels for superior quality and reliable performance.",
    keywords: "Amogh brand utensils, premium aluminum cookware, Amogh aluminum products, quality kitchen utensils, restaurant cookware",
    canonical: "/brands/amogh",
    ogImage: "/images/finished-products.jpg"
  },
  
  contactOverview: {
    title: "Contact BB Industry - Aluminium Manufacturing & Trading",
    description: "Contact BB Industry for aluminium manufacturing and trading solutions. Head office in Bhubaneswar, manufacturing facility in Balangir, Odisha. Get in touch for business inquiries.",
    keywords: "contact BB Industry, aluminium manufacturer contact, Balangir manufacturing contact, Bhubaneswar office, aluminum business inquiry",
    canonical: "/contact/overview",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  enquiry: {
    title: "Business Enquiry Form - Get Quote for Aluminium Products",
    description: "Submit your business enquiry for aluminium products and services. Get customized quotes for sheets, blanks, utensils, and scrap trading requirements from BB Industry.",
    keywords: "aluminium product enquiry, aluminum quote request, business inquiry form, metal product pricing, aluminum manufacturing quote",
    canonical: "/contact/enquiry-form",
    ogImage: "/images/bb-logo.png"
  },
  
  information: {
    title: "Contact Information - BB Industry Locations & Details",
    description: "Complete contact information for BB Industry. Head office in Bhubaneswar, manufacturing unit in Balangir, Odisha. Phone, email, and address details for all departments.",
    keywords: "BB Industry contact details, Balangir manufacturing address, Bhubaneswar office contact, aluminum company phone, manufacturing unit address",
    canonical: "/contact/information",
    ogImage: "/images/bb-facility-exterior.jpg"
  },
  
  careers: {
    title: "Careers at BB Industry - Join Our Aluminium Manufacturing Team",
    description: "Explore career opportunities at BB Industry. Join our team of professionals in aluminium manufacturing, quality assurance, sales, and operations with competitive benefits.",
    keywords: "BB Industry careers, aluminium manufacturing jobs, Balangir job opportunities, metal industry careers, manufacturing jobs Odisha",
    canonical: "/contact/work-with-us",
    ogImage: "/images/bb-facility-exterior.jpg"
  }
};

// Organization structured data
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "BB Industry",
  "alternateName": "B B Industry",
  "description": "Premier aluminium manufacturing and trading company specializing in sheets, blanks, utensils, and scrap trading with ISO certified quality standards.",
  "url": "https://bbindustry.com",
  "logo": "https://bbindustry.com/images/bb-logo.png",
  "image": "https://bbindustry.com/images/bb-facility-exterior.jpg",
  "telephone": "+91-123-456-7890",
  "email": "info@bbindustry.com",
  "foundingDate": "2009",
  "numberOfEmployees": "90",
  "industry": "Aluminium Manufacturing and Trading",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Manufacturing Facility",
    "addressLocality": "Balangir",
    "addressRegion": "Odisha",
    "addressCountry": "IN"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+91-123-456-7890",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi", "Odia"]
    },
    {
      "@type": "ContactPoint",
      "telephone": "+91-123-456-7891",
      "contactType": "sales",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/bb-industry",
    "https://www.facebook.com/bbindustry"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Aluminium Products",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Aluminium Sheets",
          "description": "High-quality aluminium sheets for industrial applications"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Aluminium Blanks",
          "description": "Precision aluminium blanks for manufacturing"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Aluminium Utensils",
          "description": "Premium aluminium utensils and cookware"
        }
      }
    ]
  }
};

// Local Business structured data
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "BB Industry",
  "image": "https://bbindustry.com/images/bb-facility-exterior.jpg",
  "description": "Leading aluminium manufacturing facility in Balangir, Odisha with state-of-the-art rolling mills and quality assurance laboratory.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Manufacturing Facility",
    "addressLocality": "Balangir",
    "addressRegion": "Odisha",
    "postalCode": "767001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 20.7099,
    "longitude": 83.4892
  },
  "telephone": "+91-123-456-7890",
  "email": "info@bbindustry.com",
  "url": "https://bbindustry.com",
  "openingHours": "Mo-Sa 09:00-18:00",
  "priceRange": "$$",
  "paymentAccepted": "Cash, Check, Bank Transfer",
  "currenciesAccepted": "INR",
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "serviceArea": {
    "@type": "Country",
    "name": "India"
  }
};